export class Totp {
  constructor({ secret, signature, qr, generatedAt }) {
    Object.assign(this, { secret, signature, qr, generatedAt });
  }
}
